import styled from "styled-components";

import InputLabel from "../../../styles/input/InputLabel.styled";
import { SmallPrint } from "../../../styles/typography/SmallPrint.styled";
import { StyledTextInputProps } from "./StyledTextInput.styled";

export const StyledTextInput = styled.div<StyledTextInputProps>`
  min-width: 250px;
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.borderRadiusInput};
  padding: ${({ theme }) => theme.paddingInput};
  color: ${({ theme, disabled, error, focused }) => {
    if (disabled) {
      return `${theme.colors.base4}`;
    }

    return `${theme.colors.base5}`;
  }};

  border-top: ${({ theme, disabled, error, focused }) => {
    if (!theme.borderedInput) {
      return "none";
    }

    if (disabled) {
      return `${theme.borderWidthInput} solid ${theme.colors.disabled1}`;
    }

    if (error) {
      return `${theme.borderWidthInput} solid ${theme.colors.highlight3}`;
    }

    if (focused) {
      return `${theme.borderWidthInput} solid ${theme.colors.activeInput}`;
    }

    return `${theme.borderWidthInput} solid ${theme.colors.base3}`;
  }};

  border-left: ${({ theme, disabled, error, focused }) => {
    if (!theme.borderedInput) {
      return "none";
    }

    if (disabled) {
      return `${theme.borderWidthInput} solid ${theme.colors.disabled1}`;
    }

    if (error) {
      return `${theme.borderWidthInput} solid ${theme.colors.highlight3}`;
    }

    if (focused) {
      return `${theme.borderWidthInput} solid ${theme.colors.activeInput}`;
    }

    return `${theme.borderWidthInput} solid ${theme.colors.base3}`;
  }};

  border-right: ${({ theme, disabled, error, focused }) => {
    if (!theme.borderedInput) {
      return "none";
    }

    if (disabled) {
      return `${theme.borderWidthInput} solid ${theme.colors.disabled1}`;
    }

    if (error) {
      return `${theme.borderWidthInput} solid ${theme.colors.highlight3}`;
    }

    if (focused) {
      return `${theme.borderWidthInput} solid ${theme.colors.activeInput}`;
    }

    return `${theme.borderWidthInput} solid ${theme.colors.base3}`;
  }};

  border-bottom: ${({ theme, disabled, error, focused }) => {
    if (disabled) {
      return `${theme.borderWidthInput} solid ${theme.colors.disabled1}`;
    }

    if (error) {
      return `${theme.borderWidthInput} solid ${theme.colors.highlight3}`;
    }

    if (focused) {
      return `${theme.borderWidthInput} solid ${theme.colors.activeInput}`;
    }

    return `${theme.borderWidthInput} solid ${theme.colors.base3}`;
  }};

  ${SmallPrint}:first-child {
    color: ${(props) => props.theme.colors.base5};
  }

  ${InputLabel} {
    margin-bottom: 2px;
  }

  ${SmallPrint}:last-child {
    color: ${(props) => props.theme.colors.alert};
  }
`;
